/* iSpice cart - 2026-10-06
   1) "Added to cart" panel on every page (right side on desktop, bottom sheet on phones)
   2) Cart page: short product names, summary card, free-shipping progress, trust row
   Works on top of the theme's own cart; if anything here fails, the theme's cart still works. */
(function () {
  'use strict';
  var FREE_SHIP = 35; // USD, lower 48 states (matches the store's shipping offer)
  var SIZE = /\b\d+(?:\.\d+)?\s?(?:oz|ounce|ounces|lb|lbs|g|gr|kg|ml|pack|pk|ct|count)\b/i;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shortName(title) {
    var parts = String(title || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length < 2) return { name: title, size: '' };
    if (/^ispice( blend)?$/i.test(parts[0])) parts.shift();
    var name = parts.shift() || title, size = '';
    parts.some(function (p) { var m = p.match(SIZE); if (m) { size = m[0]; return true; } return false; });
    return { name: name, size: size };
  }
  function shipHTML(totalCents) {
    var left = FREE_SHIP * 100 - totalCents;
    var pct = Math.max(4, Math.min(100, Math.round(totalCents / (FREE_SHIP * 100) * 100)));
    var msg = left > 0
      ? 'You are <b>' + money(left) + '</b> away from <b>free shipping</b>'
      : '<b>You have unlocked free shipping</b>';
    return '<div class="isc-ship' + (left > 0 ? '' : ' is-done') + '"><p>' + msg + '</p>' +
      '<div class="isc-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>' +
      '<small>Free US shipping over $' + FREE_SHIP + ' (lower 48 states)</small></div>';
  }
  var TRUST = '<ul class="isc-trust">' +
    '<li><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Secure checkout</li>' +
    '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>100% satisfaction guarantee</li>' +
    '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 19c2-8 7-12 14-14-1 7-5 12-13 14"/><path d="M5 19l7-7"/></svg>Made fresh in the USA</li></ul>';

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  /* ───────── 1) added-to-cart panel ───────── */
  var panel, lastFocus;
  function buildPanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'isc-drawer';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Added to cart');
    panel.innerHTML = '<div class="isc-drawer__scrim" data-isc-close></div><div class="isc-drawer__card" tabindex="-1"></div>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) { if (e.target.closest('[data-isc-close]')) { e.preventDefault(); closePanel(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel(); });
    return panel;
  }
  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    Array.prototype.forEach.call(document.querySelectorAll('.header-cart.show-mini-cart'), function (h) { h.classList.remove('show-mini-cart'); });
    document.documentElement.classList.remove('isc-lock');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  function openPanel(item, cart) {
    if (/^\/cart\/?$/.test(location.pathname)) return; // the cart page updates itself
    buildPanel();
    var n = shortName(item.product_title || item.title);
    var variant = item.variant_title && !/default title/i.test(item.variant_title) ? item.variant_title : (n.size || '');
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
    var qty = item.quantity || 1;
    panel.querySelector('.isc-drawer__card').innerHTML =
      '<div class="isc-drawer__head"><span class="isc-tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><h2>Added to your cart</h2>' +
      '<button type="button" class="isc-x" data-isc-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="isc-item">' + (img ? '<span class="isc-item__img"><img src="' + esc(img) + '" alt=""></span>' : '') +
      '<div><p class="isc-item__name">' + esc(n.name) + '</p>' + (variant ? '<p class="isc-item__meta">' + esc(variant) + '</p>' : '') +
      '<p class="isc-item__price">' + (qty > 1 ? qty + ' × ' : '') + money(item.final_price || item.price) + '</p></div></div>' +
      shipHTML(cart.total_price) +
      '<div class="isc-sub"><span>Subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ')</span><b>' + money(cart.total_price) + '</b></div>' +
      '<div class="isc-btns"><a class="isc-btn isc-btn--main" href="/checkout">Checkout</a><a class="isc-btn" href="/cart">View cart</a></div>' +
      '<button type="button" class="isc-keep" data-isc-close>Keep shopping</button>' + TRUST;
    lastFocus = document.activeElement;
    // the theme opens its own small cart after an add on phones - close it so only one shows
    var hideMini = function () { Array.prototype.forEach.call(document.querySelectorAll('.header-cart.show-mini-cart'), function (h) { h.classList.remove('show-mini-cart'); }); };
    hideMini(); setTimeout(hideMini, 300); setTimeout(hideMini, 900);
    // let the theme finish its own update first, then slide in
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      document.documentElement.classList.add('isc-lock');
      var x = panel.querySelector('.isc-x'); if (x) x.focus({ preventScroll: true });
    });
  }
  function onAdded(data) {
    var item = data && (data.items ? data.items[0] : data);
    if (!item || !(item.product_title || item.title)) return;
    getCart().then(function (cart) { openPanel(item, cart); }).catch(function (e) { console.warn('ispice-cart', e); });
  }
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '').split('#')[0].replace(location.origin, '')); }

  // the theme adds with jQuery (XMLHttpRequest); homepage sections add with fetch - watch both
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__iscAdd = isAdd(u); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__iscAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) { try { onAdded(JSON.parse(this.responseText)); } catch (e) { getCart().then(function (c) { if (c.items[0]) openPanel(c.items[0], c); }); } }
      });
    }
    return XS.apply(this, arguments);
  };
  if (window.fetch) {
    var F = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = F.apply(this, arguments);
      if (isAdd(url)) {
        p.then(function (r) { if (r.ok) r.clone().json().then(onAdded).catch(function () {}); }).catch(function () {});
      }
      return p;
    };
  }

  /* ───────── 2) cart page ───────── */
  function enhanceCartPage() {
    if (!document.body.classList.contains('cart')) return;
    var list = document.querySelector('.cart-section .cart__item-list');
    if (!list) return;
    // short names
    Array.prototype.forEach.call(list.querySelectorAll('.cart__card .item__title'), function (p) {
      if (p.dataset.iscDone) return;
      var a = p.querySelector('a') || p;
      var full = a.textContent.replace(/\s+/g, ' ').trim();
      var n = shortName(full);
      if (n.name && n.name !== full) {
        p.dataset.iscDone = '1';
        a.setAttribute('title', full);
        a.textContent = n.name;
        if (n.size) { var m = document.createElement('span'); m.className = 'isc-size'; m.textContent = n.size; p.appendChild(m); }
      }
    });
    // summary card: subtotal + checkout area together, with shipping progress and trust row
    var sum = list.querySelector('.isc-summary');
    var cost = list.querySelector('.cart__cost-summary');
    var checkout = list.querySelector('.cart__price-breakdown');
    if (!sum && cost && checkout) {
      sum = document.createElement('aside');
      sum.className = 'isc-summary';
      sum.innerHTML = '<h2 class="isc-summary__title">Order summary</h2><div class="isc-summary__ship"></div>';
      list.appendChild(sum);
      sum.appendChild(cost);
      sum.appendChild(checkout);
      var t = document.createElement('div'); t.innerHTML = TRUST; sum.appendChild(t.firstChild);
      // the theme's now-empty wrappers leave a gap on phones
      Array.prototype.forEach.call(list.querySelectorAll(':scope > .container:not(.cart__card)'), function (c) { if (!c.textContent.trim() && !c.querySelector('img,iframe,shopify-accelerated-checkout-cart')) c.style.display = 'none'; });
    }
    if (sum) getCart().then(function (c) { var s = sum.querySelector('.isc-summary__ship'); if (s && s.dataset.total !== String(c.total_price)) { s.dataset.total = String(c.total_price); s.innerHTML = shipHTML(c.total_price); } }).catch(function () {});
  }

  function start() {
    try { enhanceCartPage(); } catch (e) { console.warn('ispice-cart page', e); }
    var sec = document.querySelector('.cart-section');
    if (sec && 'MutationObserver' in window) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { try { enhanceCartPage(); } catch (e) {} }, 120); }).observe(sec, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
